import { render, staticRenderFns } from "./imgInfo.vue?vue&type=template&id=f4486f02"
import script from "./imgInfo.vue?vue&type=script&lang=js"
export * from "./imgInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports